/** Single blueprint glyph for tabs, empty states, setup cards, and header actions. */
export const BLUEPRINT_ICON = "fa-table-cells-large" as const

export const blueprintIconClass = (weight: "light" | "solid" = "light") =>
  `fa-${weight} ${BLUEPRINT_ICON}`
